import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { TDUDetailsComponent } from './tdu-details/tdu-details.component';
import { TduDetailsPageComponent } from './tdu-details-page/tdu-details-page.component';


const routes: Routes = [ 
  // { path: 'enroll/zipcode/:zipcode', component: TDUDetailsComponent, },
  { path: 'enroll/zipcode/:zipcode', component: TduDetailsPageComponent, },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceAvailabilityRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/service-availability/service-availability-routing.module.ts